<template>
  <div class="add-condition">
    <div @click="openNewConditionPicker" :class="{ disabled: disabled }">
      <n-tooltip position="top" :text="tooltip">
        <slot>
          <a>
            <AddIcon></AddIcon>
            <span class="add-label">Add filter</span>
          </a>
        </slot>
      </n-tooltip>
    </div>
    <ConditionPicker
      v-if="isConditionPickerOpen"
      v-click-away="closeNewConditionPicker"
      :available-conditions="availableConditions"
      @selected="onConditionAdded"
      @cancel="closeNewConditionPicker"
    >
    </ConditionPicker>
  </div>
</template>

<script lang="ts" setup>
import { ConditionViewModel } from './models/conditionViewModel';
import { ConditionPickerOption } from './models/conditions';
import ConditionPicker from './ConditionPicker.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import { PropType, ref } from 'vue';

const props = defineProps({
  availableConditions: {
    type: Array as PropType<ConditionPickerOption[]>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
  },
});

const emit = defineEmits<{
  (e: 'added', condition: ConditionViewModel): void;
}>();

const isConditionPickerOpen = ref(false);

function openNewConditionPicker() {
  if (props.disabled) {
    return;
  }

  isConditionPickerOpen.value = true;
}

function closeNewConditionPicker() {
  isConditionPickerOpen.value = false;
}

function onConditionAdded(condition: ConditionViewModel) {
  closeNewConditionPicker();
  emit('added', condition);
}
</script>

<style scoped lang="scss">
.disabled {
  opacity: 0.6;
  cursor: not-allowed;

  a {
    color: #363636;
    cursor: not-allowed;
  }
}

:deep(.add-label) {
  margin-left: 0.25em;
}

.add-condition {
  position: relative;
}
</style>
